import {
  Banknote,
  BriefcaseBusiness,
  CalendarX2,
  CheckCheck,
  ClipboardList,
  FileCheck2,
  FileText,
  History,
  Flag,
  Languages,
  LayoutDashboard,
  MapPinned,
  Layers,
  ListChecks,
  ReceiptText,
  Repeat,
  Percent,
  ShieldCheck,
  SlidersHorizontal,
  TicketPercent,
  type LucideIcon,
  MessageSquareWarning,
  Scale,
  Sparkles,
  UserCheck,
  Users,
  Wallet,
} from "lucide-react";
import type { Permission } from "@poji/shared";

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  /** yoksa herkese (yönetici) açık */
  permission?: Permission;
}

/** Menü yetkiye göre süzülür (K-092); asıl kontrol API'de. Yeni ekran = buraya bir satır + route. */
export const NAV: { group: string; items: NavItem[] }[] = [
  {
    group: "Genel",
    items: [{ to: "/", label: "Genel bakış", icon: LayoutDashboard }],
  },
  {
    group: "Operasyon",
    items: [
      { to: "/tasks", label: "İşler", icon: ClipboardList, permission: "tasks.view" },
      { to: "/missing-receipts", label: "Eksik fiş", icon: ReceiptText, permission: "tasks.view" },
      { to: "/series", label: "Düzenli işler", icon: Repeat, permission: "tasks.view" },
      { to: "/users", label: "Kullanıcılar", icon: Users, permission: "users.view" },
      { to: "/disputes", label: "İtirazlar", icon: Scale, permission: "tasks.disputes.manage" },
      {
        to: "/approvals",
        label: "Dört göz onayı",
        icon: CheckCheck,
        permission: "staff.approvals.decide",
      },
    ],
  },
  {
    group: "Hizmet verenler",
    items: [
      {
        to: "/providers",
        label: "Başvurular",
        icon: UserCheck,
        permission: "providers.applications.review",
      },
      {
        to: "/documents",
        label: "Belgeler",
        icon: FileCheck2,
        permission: "providers.verification.manage",
      },
    ],
  },
  {
    group: "Destek ve içerik",
    items: [
      {
        to: "/reports",
        label: "İçerik bildirimleri",
        icon: Flag,
        permission: "support.reports.moderate",
      },
      {
        to: "/messages",
        label: "İşaretli mesajlar",
        icon: MessageSquareWarning,
        permission: "support.reports.moderate",
      },
    ],
  },
  {
    group: "İçerik",
    items: [{ to: "/pages", label: "Sayfalar", icon: FileText, permission: "cms.pages.edit_all" }],
  },
  {
    group: "Katalog",
    items: [
      { to: "/catalog", label: "Hizmetler", icon: Layers, permission: "catalog.services.manage" },
      { to: "/forms", label: "Formlar", icon: ListChecks, permission: "catalog.forms.manage" },
      {
        to: "/service-requests",
        label: "Hizmet talepleri",
        icon: Sparkles,
        permission: "catalog.services.manage",
      },
      {
        to: "/translations",
        label: "Çeviriler",
        icon: Languages,
        permission: "catalog.translations.manage",
      },
      { to: "/fees", label: "Ücret kuralları", icon: Percent, permission: "settings.fees.manage" },
      {
        to: "/promotions",
        label: "Kampanyalar",
        icon: TicketPercent,
        permission: "marketing.promotions.manage",
      },
    ],
  },
  {
    group: "Finans",
    items: [
      {
        to: "/accounting",
        label: "Muhasebe",
        icon: Banknote,
        permission: "accounting.ledger.view",
      },
      {
        to: "/payouts",
        label: "Hizmet veren ödemeleri",
        icon: Wallet,
        permission: "accounting.ledger.view",
      },
    ],
  },
  {
    group: "Yönetim",
    items: [
      {
        to: "/settings",
        label: "Pazar ayarları",
        icon: SlidersHorizontal,
        permission: "settings.markets.manage",
      },
      {
        to: "/geo",
        label: "Bölgeler",
        icon: MapPinned,
        permission: "settings.markets.manage",
      },
      {
        to: "/cancellation",
        label: "İptal kuralları",
        icon: CalendarX2,
        permission: "settings.markets.manage",
      },
      { to: "/staff", label: "Ekip ve roller", icon: ShieldCheck, permission: "staff.manage" },
      { to: "/audit", label: "Denetim kaydı", icon: History, permission: "staff.audit.view" },
    ],
  },
];

export const BRAND_ICON = BriefcaseBusiness;
